import * as React from 'react'

import { LightTooltip } from '@sales-center/components'

import { useData, useHandlers } from './hooks'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import Chip from '@mui/material/Chip'
import { ScrollToErrorMarker } from '../ScrollToErrorMarker'

export type TargetPestsProps = Pick<
  Required<TextFieldProps>,
  'margin' | 'size'
> & {
  name?: string
  required?: boolean
  textFieldProps?: TextFieldProps
}

export function TargetPests(props: TargetPestsProps) {
  const { required, size, margin, name, textFieldProps } = props

  const { onChange } = useHandlers()
  const { showError, helperText, value, options } = useData(props)

  return (
    <>
      <ScrollToErrorMarker fieldName={name} />
      <Autocomplete<{ label: string; value: string }, true>
        multiple
        value={value}
        options={options}
        onChange={onChange}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            size={size}
            error={showError}
            variant="outlined"
            required={required}
            label="Target Pests"
            margin={margin}
            helperText={helperText}
            data-test-id="targetPestsInput"
            {...textFieldProps}
          />
        )}
        renderTags={(value, getTagProps) =>
          value.map((v, index) => (
            <LightTooltip key={index} title={v.label}>
              <Chip
                size={size}
                label={v.label}
                color="primary"
                {...getTagProps({ index })}
              />
            </LightTooltip>
          ))
        }
      />
    </>
  )
}
